import Vue from 'vue'
import loadingVue from './MyLoading.vue'

const MessageBoxConstructor = Vue.extend(loadingVue)
const instance = new MessageBoxConstructor({
  el: document.createElement('div')
})

instance.vm = instance.$mount()
document.body.appendChild(instance.vm.$el)

instance.show = function (tips) {
  instance.vm.$el.style.display = 'flex'
  if (tips) {
    instance.vm.tips = tips
  }
}

instance.hide = function () {
  instance.vm.$el.style.display = 'none'
}

export default instance



// WEBPACK FOOTER //
// ./src/components/MyLoading/src/MyLoading.js